import { makeStyles } from "@material-ui/core/styles";

const UseStyles = makeStyles((theme) => ({
  nmef_spinner_container: {
    display: "flex",
    justifyContent: "center",
  },
  sr_only: {
    fontSize: "large",
    fontWeight: "bolder",
    marginLeft: "10px",
  },
}));

export default UseStyles;
